module.exports = __webpack_public_path__ + "assets/images/JMDBAG5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBAG5.png
// module id = 1393
// module chunks = 1